/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { useCustomer } from "~/context/User/Customer";
import { CustomerRequest } from "~/models";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type Props = {
  request: CustomerRequest;
  refetch: () => Promise<void>;
};

export default function ({ request, refetch }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();
  const { Axios } = useAxios();
  const { customer } = useCustomer();

  const unassignRequest = async () => {
    try {
      await Axios().delete(`/customers/${customer.id}/requests/${request.id}`);
      refetch();
      showSuccess(
        generateActionSuccessText(`Request ${request.name}`)()("unassigned")()
      );
    } catch (e) {
      showError(e.response);
    }
    setIsOpen(false);
  };

  return (
    <>
      <Button
        icon="brokenLink"
        size="sm"
        onClick={() => setIsOpen(true)}
        severity="low"
      >
        Unassign
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={unassignRequest}
        actionLabel="Unassign"
        contentLabel="Unassign Request"
      >
        {generateActionConfirmText(`request ${request.name}`)("unassign")()}
      </ModalConfirm>
    </>
  );
}
